export enum AGENT_MESSAGE_DIRECTION {
  TO_AGENT = 0,
  TO_ANONYMOUS = 1,
}
export interface IAgentMessage {
  direction: AGENT_MESSAGE_DIRECTION;
  data: {
    message_id: string;
    content: string;
  };
}
